<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "InvitePage",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'invitePage:add',
        update: 'invitePage:update',
        delete: 'invitePage:delete',
        deleteBatch: 'invitePage:deleteBatch'
      },
      url: {
        get: '/invitePage/listByCondition',
        add: '/invitePage/add',
        update: '/invitePage/update',
        delete: '/invitePage/delete/',
        delete_batch: '/invitePage/deleteBatch',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select'
        },
        width: '',
      }, {
        field: 'awardMoney',
        label: '金额',
        show: true,
        width: '',
      }, {
        field: 'content',
        label: '内容',
        show: true,
        width: '',
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      operate: [],
      formFields: {
        addTitle: '添加滚动公告',
        updateTitle: '修改滚动公告',
        model: [{
          field: 'agentId',
          label: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
          placeholder: '请选择',
          rules: [{
            message: '请选择代理', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'awardMoney',
          label: '金额',
          type: 'textarea',
          placeholder: '金额',
          rules: [{message: '请输入金额', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'content',
          label: '内容',
          type: 'textarea',
          placeholder: '内容',
          rules: [{message: '请输入内容', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
